import type { FaireProductEntity } from "../../entity_types/product";

export const p_nawyp2ks2e: FaireProductEntity = {
  token: "p_nawyp2ks2e",
  type: "product",
  name: "Bean Salsa Verde Walking Tamales, 7 Pouches/Case",
  brandToken: "b_2punudte8l",
  brandName: "FILLO'S",
  imageUrl:
    "https://cdn.faire.com/fastly/0403198f555c8a6a4021f1fa6ed574d6d3ad6eb8ff1c2756b2308ec8823ffcbd.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/ee45449ae1ee8432d00112d9de4912ad211bf950a1e8c5d5b20acb882793aba5.png",
    "https://cdn.faire.com/fastly/031711e4a4a1d81d82d8f280d0015a81576a7f56a06c5f5db1e0293643133d7a.jpeg",
  ],
  priceDollars: 14.99,
  description:
    "Ready to eat tamales made with simple ingredients. Real sabor is at hand, wherever you’re headed.\n\nNon-GMO Project Verified, Shelf-stable, ready to eat, vegan friendly, plant protein, made with Extra Virgin Olive Oil",
  tags: [],
  msrpDollars: 29.98,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-05T05:28:20.639Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
